const appTheme = {
  current: process.env.REACT_APP_THEME_DEFAULT,
}

export default appTheme.current
